import styled from 'styled-components'
import { Grid as GridMaterial } from '@material-ui/core'

const Grid = styled(GridMaterial)`
  margin: 0;
`

export default Grid
